document.addEventListener('DOMContentLoaded', function() {
  const sectionEl = document.querySelector('subscription-modal');
  const checkoutTriggerEnabled = sectionEl && sectionEl.dataset.checkoutTrigger !== 'false';

  function showModal(e) {
    if (!checkoutTriggerEnabled) return;
    if (sessionStorage.getItem('modal_shown')) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    sessionStorage.setItem('modal_shown', 'true');

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      const closeBtn = cartDrawer.querySelector('[on\\:click="cart-drawer-component/close"]');
      if (closeBtn) closeBtn.click();
    }

    setTimeout(() => {
      const modal = document.querySelector('subscription-modal');
      if (modal) modal.show();
    }, 300);
  }

  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.id === 'cart-form' || form.getAttribute('action') === '/checkout') {
      showModal(e);
    }
  }, true);

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('#checkout, [name="checkout"], .cart__checkout-button');
    if (btn) showModal(e);
  }, true);
});
